import React, {useRef} from 'react'
import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Text,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import UniversalFeedbackRecommended from '../../recommended-products/universal-feedback-recommended'
import {CloseIcon} from '../../icons'

const SubscriptionModal = ({isOpen, onClose, isSubscription = false, itemsAdded = []}) => {
    const styles = useMultiStyleConfig('SubscriptionModal', {})

    const {data: basket} = useCurrentBasket()

    // we need a ref here to persist the recommendations when you add a new product from inside the modal
    const recommendations = useRef(null)

    // if the modal is closed, we reset the recommendations, tried added it to the onClose of the modal
    // but when closed and with null recommendations, it rerenders and it reset to the previous ones from the basket
    if (!isOpen) {
        recommendations.current = null
    }

    // for some pages we removed the recommendations inside the product in order to optimize the performance (for example plp)
    // so we get them from the basket.
    if (basket?.c_additionalData?.recommendations && !recommendations.current) {
        recommendations.current = basket?.c_additionalData?.recommendations
    }

    if (isSubscription && itemsAdded.length > 0) {
        recommendations.current = itemsAdded[0]?.product?.c_recommendations?.filter((rec) => {
            return rec?.recommendationType?.value === 4
        })
    }

    const recommendedProductIds = (recommendations.current || [])
        .filter(
            (rec) => rec?.recommendationType?.value === 2 || rec?.recommendationType?.value === 4,
        )
        .map((rec) => rec?.recommendedItemId)
        .filter(Boolean)

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay bg="blackAlpha.700" />

            <ModalContent {...styles.modalContent}>
                <ModalHeader {...styles.modalHeader}>
                    <FormattedMessage
                        id="subscription_modal.label.title"
                        defaultMessage="Subscription"
                    />

                    <CloseIcon onClick={onClose} {...styles.closeButtonIcon} />
                </ModalHeader>

                <ModalBody {...styles.modalBody}>
                    <Text>
                        <FormattedMessage
                            id="subscription_modal.label.description"
                            defaultMessage="Manage your subscription options from here."
                        />
                    </Text>

                    <UniversalFeedbackRecommended
                        isSubscription={isSubscription}
                        products={recommendedProductIds}
                    />
                </ModalBody>

                <ModalFooter {...styles.modalFooter}>
                    <Button onClick={onClose} variant="link-button" size={'base'}>
                        <FormattedMessage
                            id="subscription_modal.label.close"
                            defaultMessage="Close"
                        />
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
export default SubscriptionModal

SubscriptionModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    isSubscription: PropTypes.bool,
    itemsAdded: PropTypes.array,
}
